import React from 'react';
import ModellingTree from './components/ModellingTree';
import { useMDCockpit } from '../../hooks/useMDCockpit';
import styles from './LeftSideBar.module.scss';
import CustomToolTip from '../../../../CommonComponents/CustomToolTip';

const PanelCollapseIcon = ({ collapsed }: { collapsed: boolean }) => (
  <svg
    width="7"
    height="8"
    viewBox="0 0 7 8"
    fill="none"
    style={{ transform: collapsed ? 'rotate(180deg)' : undefined }}
    aria-hidden="true"
  >
    <g className={styles.toggleChevronGroup}>
      <path d="M5.86328 0.28888L3.07757 3.53888L5.86328 6.78888" stroke="#F0F0F0" strokeWidth="0.577778" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.07422 0.28888L0.288504 3.53888L3.07422 6.78888" stroke="#F0F0F0" strokeWidth="0.577778" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

const LeftSideBar: React.FC = () => {
  const { leftPanelCollapsed, setLeftPanelCollapsed, timelineCollapsed, timelineHeight } = useMDCockpit();
  const timelineVisibleHeight = timelineCollapsed ? 34 : timelineHeight;
  const panelBottomOffset = timelineVisibleHeight + 40;

  return (
    <>
      <div
        className={`${styles.panel} ${leftPanelCollapsed ? styles.panelHidden : ''}`}
        style={{ '--left-panel-bottom': `${panelBottomOffset}px` } as React.CSSProperties}
      >
        <div className={styles.body}>
          <ModellingTree />
        </div>
      </div>

      <CustomToolTip
        title={leftPanelCollapsed ? 'Show panel' : 'Hide panel'}
        placement="right"
        className={`${styles.toggleTab} ${leftPanelCollapsed ? styles.toggleTabCollapsed : ''}`}
      >
        <button
          type="button"
          style={{
            width: '100%',
            height: '100%',
            background: 'transparent',
            border: 'none',
            outline: 'none',
            cursor: 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => setLeftPanelCollapsed(!leftPanelCollapsed)}
        >
          <svg
            className={styles.toggleBg}
            width="41"
            height="12"
            viewBox="0 0 41 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.toggleBgPath}
              d="M0 4C2.89694e-07 1.79087 1.79086 -2.89694e-07 4 0L41 4.85196e-06V1.7723C41 3.00263 40.0026 4.00001 38.7723 4.00001C37.8134 4.00001 36.9621 4.61358 36.6589 5.52325L35.4117 9.26492C34.8672 10.8983 33.3387 12 31.617 12H9.38304C7.66132 12 6.13276 10.8983 5.58831 9.26492L4.74503 6.73509C4.20057 5.10172 2.67202 4 0.950299 4H0Z"
              fill="rgba(9, 9, 9, 0.55)"
            />
            <path
              d="M4 0.249999H40.75V1.77246C40.7499 2.86459 39.8646 3.74991 38.7725 3.75C37.706 3.75 36.7591 4.43259 36.4219 5.44434L35.1748 9.18555C34.6644 10.7168 33.2312 11.7499 31.617 11.75H9.38281C7.76879 11.7499 6.3356 10.7168 5.8252 9.18555L4.98242 6.65625C4.40394 4.9208 2.77952 3.75 0.950195 3.75H0.258789C0.387457 1.79551 2.01295 0.249999 4 0.249999Z"
              stroke="url(#toggleStrokeGradient)"
              strokeWidth="0.5"
            />
            <defs>
              <linearGradient id="toggleStrokeGradient" x1="32.1328" y1="12" x2="32.1328" y2="-3" gradientUnits="userSpaceOnUse">
                <stop stopColor="#3F3F3F" />
                <stop offset="0.5649" stopColor="#3F3F3F" />
                <stop offset="0.565" stopColor="#3F3F3F" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
          <span className={styles.toggleChevron}>
            <PanelCollapseIcon collapsed={leftPanelCollapsed} />
          </span>
        </button>
      </CustomToolTip>
    </>
  );
};

export default LeftSideBar;
